import { IonCard } from "@ionic/react";
import React from "react";

import classNames from "classnames/bind";
import CardHeader from "./CardHeader";
import CardContent from "./CardContent";
import WishlistButton from "./WishlistButton";
import { Product } from "@core/types";

import styles from "./MainPageProduct.module.scss";
import "./MainPageProduct.scss";

interface ProductCartProps {
  product: Product;
  lazyload?: boolean;
}

const cx = classNames.bind(styles);

const MainPageProduct = ({ product, lazyload }: ProductCartProps) => {
  return (
    <div className={cx("skeletonWidth", "product-component", "product")}>
      <IonCard
        title={product.name}
        className={cx(
          "card-wrapper",
          "ion-no-margin ion-margin-top animated fadeIn",
          "productCommon__card",
          "cardShadow",
          "min-h-[14rem] md:min-h-[13rem] flex flex-col justify-between p-[5px]"
        )}
      >
        <CardHeader lazyload={lazyload} product={product} />
        <CardContent product={product} />
        <WishlistButton productId={product.id} />
      </IonCard>
    </div>
  );
};

MainPageProduct.displayName = "CORE_MainPageProduct";

export default MainPageProduct;
